/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./takingregularincome.scss";
import { FUNDTYPE, RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  addCommas,
  calculateMonthlyIncome,
  calculateVintage,
  COLOR_PALETTE,
  findFunds,
  hasContextPath,
  openPopup,
  parseInputValue,
  sanitizeInputOnBlur,
} from "../../helpers/helpers";
import { ModalOverlay } from "../../atoms/Modal";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import Slider from "../../atoms/Range/Slider";
import LoadingSpinner from "../../atoms/Loader";
import { useNavigate } from "react-router-dom";
import { RegularIncomeContext } from "../../context/RAContextProviders/regularIncomeContext";

const TakingRegularIncome = (props) => {
  const { cardData } = props;
  const { regularchoice } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const { data: personalData } = useSelector(
    (state) => state.home // eslint-disable-line
  );
  const navigate = useNavigate(); // eslint-disable-line
  const {
    isRegularIncomeSection,
    flexiValueRegularIncome,
    miValueRegularIncome,
    faiValueRegularIncome,
    resetRegularIncomeValues,
  } = useContext(RegularIncomeContext);

  const generateProductOverviewLink = (parentStrategyName, strategyName) => {
    const productOverview = cardData?.items?.filter((productOverview) => {
      return (
        productOverview.contentType === "questionPage" &&
        productOverview.name === parentStrategyName
      );
    });
    let tptProductRoute =
      productOverview[0]?.properties?.optionItem?.items?.filter?.(
        (item) =>
          item?.content?.properties?.retirementOptionListTitle === strategyName,
      );

    let finalPath =
      tptProductRoute[0]?.content?.properties?.cTA[0]?.route?.path.replace(
        "/guidance/",
        "",
      );
    navigate(`/product-overview/?${finalPath.replace(/\/$/, "")}`, {
      state: {
        doNotCallGetApi: true,
        isRegularIncome: true,
        flexiSliderValue: parseFloat(flexiSliderValue),
        miSliderValue: parseFloat(miSliderValue),
        futureSliderValue: parseFloat(futureSliderValue),
      },
    });
  };
  const dispatch = useDispatch();

  const { getHomePageContent, FutureCalculatorHomeContent } =
    bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    if (Object.keys(personalData).length === 0) {
      getHomePageContent(props.investorId);
    }
    if (isRegularIncomeSection) {
      setFlexiSliderValue(flexiValueRegularIncome);
      setMiSliderValue(miValueRegularIncome);
      setFutureSliderValue(faiValueRegularIncome);

      // clear mix and match context states
      resetRegularIncomeValues();
    }
  }, []);

  useEffect(() => {
    FutureCalculatorHomeContent(props.investorId);
  }, []);

  const [miSliderValue, setMiSliderValue] = useState(0);
  const [futureSliderValue, setFutureSliderValue] = useState(0);
  const [flexiSliderValue, setFlexiSliderValue] = useState(0);
  const [flexiIncomePopup, setFlexiIncomePopup] = useState(false);
  const [flexiAccessDuration, setFlexiAccessDuration] = useState("Monthly");
  const [flexiAccessCurrentIncome, setFlexiAccessCurrentIncome] = useState(0);
  const [cmsStrategy, setCmsStrategy] = useState();
  const [currentPriceManaged, setCurrentPriceManaged] = useState();
  const [currentPriceFutureAnnuity, setCurrentPriceFutureAnnuity] = useState();
  const [miRate, setMiRate] = useState(0);
  const [faRate, setFaRate] = useState(0);
  const [currentIncome, setCurrentIncome] = useState(0);
  const [frequency, setFrequency] = useState("Monthly");
  const [managedForYouErrorPopup, setManagedForYouErrorPopup] = useState(false);

  const handleMiSliderChange = (e) => {
    const value = e.target.value;
    setMiSliderValue(value);
  };

  const handleMiInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setMiSliderValue(result.numericValue);
    }
  };
  const handleMiInputBlur = (e) => {
    const cleanedValue = sanitizeInputOnBlur(e.target.value);
    const result = parseInputValue(cleanedValue);
    if (result) {
      setMiSliderValue(result.numericValue);
    }
  };

  const handleFutureSliderChange = (e) => {
    const value = e.target.value;
    setFutureSliderValue(value);
  };

  const handleFutureInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setFutureSliderValue(result.numericValue);
    }
  };

  const handleFlexiInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setFlexiSliderValue(result.numericValue);
    }
  };

  const handleFlexiSliderChange = (e) => {
    const value = e.target.value;
    setFlexiSliderValue(value);
  };

  const movingToDrawdownValue =
    parseFloat(regularchoice?.riData?.movingToDrawdown.replace(/,/g, "")) || 0;

  const calculateTotalValue = (sliderValue) => {
    return (movingToDrawdownValue * sliderValue) / 100;
  };

  const totalSliderValue =
    Number(miSliderValue) +
    Number(futureSliderValue) +
    Number(flexiSliderValue);

  const isBetween0And22500 = (v) => Number.isFinite(v) && v > 0 && v < 22500;

  const handleBack = () => {
    props.makeInitialStepper(
      false,
      34,
      { isRegularHowMuchCash: true },
      true //eslint-disable-line
    );
  };

  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST;
    let regularIncome = {
      active: true,
      miAllocationPercent: parseFloat(miSliderValue),
      faIncomePercentage: parseFloat(futureSliderValue),
      miAmount: calculateTotalValue(miSliderValue).toFixed(2),
      faIncomeAmount: calculateTotalValue(futureSliderValue).toFixed(2),
      miCurrentIncome: calculateMonthlyIncome(
        calculateTotalValue(miSliderValue).toFixed(2),
        miRate,
        currentPriceManaged //eslint-disable-line
      ).toFixed(2),
      faiCurrentIncome: calculateMonthlyIncome(
        calculateTotalValue(futureSliderValue).toFixed(2),
        faRate,
        currentPriceFutureAnnuity //eslint-disable-line
      ).toFixed(2),
    };
    let payload = {
      currentStep,
      choiceCategory: { regularIncome },
    };
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST,
      payload // eslint-disable-line
    );
  };

  const handleFlexiAccessContinue = (amount, period) => {
    setFlexiAccessCurrentIncome(amount);
    setFlexiAccessDuration(
      period
        ? period === "Annually"
          ? "Annual"
          : period === "Half yearly"
            ? "HalfYearly"
            : period === "Quarterly"
              ? "Quarterly"
              : "Monthly"
        : "Monthly",
    );
    setFlexiIncomePopup(false);
  };

  const { payoutRateFetching, payoutRateData, payoutRateError } = useSelector(
    (state) => state.payoutRate,
  );
  const { raCMSFundsFetching, raCMSFundsData, raCMSFundsError } = useSelector(
    (state) => state.raCMSFunds,
  );

  const { getRACMSFunds, getPayoutRate } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );

  useEffect(() => {
    if (props.investorId) {
      if (Object.keys(raCMSFundsData).length === 0) {
        getRACMSFunds(props.investorId);
      }

      if (
        Object.keys(payoutRateData).length === 0 &&
        personalData?.timeTravel?.birthDate !== undefined
      ) {
        const birthYear = new Date(
          personalData.timeTravel.birthDate,
        ).getFullYear();
        const retirementYear = new Date(
          personalData.timeTravel.retirementDate,
        ).getFullYear();
        getPayoutRate(props.investorId, retirementYear - birthYear);
      }
    }
  }, [personalData, raCMSFundsData, payoutRateData]);

  useEffect(() => {
    setCurrentIncome(payoutRateData[0]?.currentIncome);
    setFrequency(payoutRateData[0]?.duration);
    setMiRate(payoutRateData[0]?.payOutRates?.managed_income_95_payout_rate);
    setFaRate(payoutRateData[0]?.payOutRates?.future_annuity_75_payout_rate);
    setCurrentPriceManaged(payoutRateData[0]?.managedIncomeBuyPrice);
    setCurrentPriceFutureAnnuity(payoutRateData[0]?.futureAnnuityFundBuyPrice);

    setFlexiAccessCurrentIncome(payoutRateData[0]?.currentIncome);
    setFlexiAccessDuration(payoutRateData[0]?.duration);
  }, [payoutRateData]);

  useEffect(() => {
    const vintage = calculateVintage(
      personalData?.timeTravel?.birthDate?.split("-")[0] // eslint-disable-line
    );

    var colorIndex = COLOR_PALETTE.length;
    setCmsStrategy(
      findFunds(
        raCMSFundsData?.data,
        vintage.age75Year,
        vintage.age95Year // eslint-disable-line
      )?.map(
        (item) => {
          const {
            investmentStyle,
            averageESGRating,
            fundFactsheets,
            fundUse,
            fundObjectiveTruncated,
            composerFundNameTruncated,
            investmentId,
            fundName,
            ...rest
          } = item;
          if (investmentId !== null) {
            return {
              strategyId: investmentId,
              strategyName: fundName,
              fundId: composerFundNameTruncated,
              fundType:
                investmentStyle === "Managed for you"
                  ? FUNDTYPE.MANAGED_FOR_ME
                  : investmentStyle,
              ESGRating: averageESGRating,
              managedBy: fundUse,
              shortDesc: fundObjectiveTruncated,
              pDFUrl: fundFactsheets ? fundFactsheets[0].url : null,
              strategyPercentage: 0,
              incomePercentage: 0,
              newCurrentValue: 0,
              newCurrentIncome: 0,
              currentValue: 0,
              currentIncome: 0,
              category:
                fundName.toLowerCase() === "future annuity income fund" ||
                fundName.toLowerCase() === "managed income fund"
                  ? "For Income"
                  : fundName.toLowerCase() === "legacy fund" ||
                      fundName.toLowerCase() === "safety net fund"
                    ? "For Growth"
                    : "",
              color: COLOR_PALETTE[--colorIndex],
              ...rest,
            };
          }
        } // eslint-disable-line
      ) // eslint-disable-line
    );
  }, [personalData, raCMSFundsData]);

  props.setFaiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Future Annuity Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setMiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Managed Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setLeId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Legacy Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setSnId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Safety Net Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );

  if (payoutRateFetching || raCMSFundsFetching) {
    return <LoadingSpinner width={55} />;
  }

  return (
    <>
      <Card className="application-step">
        <Card.Body className="taking-regular-income">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance _title">Taking a regular income</p>
            </Col>
          </Row>
          <Row className="invest_content">
            <Col md={6} className="invest_content-left">
              <p>
                <span className="fw-bold">Managed for you:</span>
                <br />
                {movingToDrawdownValue >= 22500 ? (
                  <>
                    If you choose a <i>Managed for you</i> option, you’ll need
                    to allocate a{" "}
                    <span className="fw-bold">minimum of £22,500</span> to
                    either of these choices.
                  </>
                ) : (
                  <>
                    <p>
                      You don’t currently have enough pension savings to access
                      this option.
                    </p>
                    <p>
                      You can add other TPT pots or transfer in other pensions
                      to reach the £30,000 minimum required.
                    </p>
                  </>
                )}
              </p>
            </Col>

            <Col md={6} className="bg-text">
              <>
                <div>
                  <div className="d-flex justify-content-between mb-1">
                    <div> Applying with:</div>
                    <div className="tb">
                      {" "}
                      {"£" + addCommas(regularchoice?.riData?.totalCash)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <div> Taking as tax-free cash:</div>
                    <div className="tb">
                      {"£" +
                        addCommas(regularchoice?.riData?.takingAsTaxFreeCash)}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <div> Moving to TPT drawdown:</div>
                    <div className="tb">
                      {" "}
                      {"£" + addCommas(regularchoice?.riData?.movingToDrawdown)}
                    </div>
                  </div>
                </div>
              </>
            </Col>
          </Row>

          <div className="managed-income">
            <div className="managed-income-heading">
              <span className="manage-heading-text">{"Managed for you"}</span>
            </div>
            {Number(regularchoice?.riData?.movingToDrawdown.replace(/,/g, "")) <
            22500 ? (
              <div className="d-flex g-4">
                <div className="locked-flexi-card">
                  <div className="flexi-card-front">
                    <div>
                      <Icons iconname="locked" variant="icon-twenty-four-px" />
                    </div>
                    <div className="manage-flexi-text">Managed income</div>
                    <div className="manage-flexi--access">
                      If you have at least £30k in pension savings in this
                      retirement application, you can access the options.
                    </div>
                  </div>
                </div>
                <div className="locked-flexi-card">
                  <div className="flexi-card-front">
                    <div>
                      <Icons iconname="locked" variant="icon-twenty-four-px" />
                    </div>
                    <div className="manage-flexi-text">
                      Future annuity income
                    </div>
                    <div className="manage-flexi--access">
                      If you have at least £30k in pension savings in this
                      retirement application, you can access the options.
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex g-4">
                <div className="retirement-card">
                  <div className="sub-header-div">
                    <span
                      className="circle ps-2 mt-1"
                      style={{
                        backgroundColor: COLOR_PALETTE[0],
                      }}
                    ></span>
                    <span className="sub-header">Managed income</span>
                  </div>
                  <hr className="upper-line" />
                  <div className="parent-text">
                    <div className="current-value-text">Current value:</div>
                    <div className="current-value">
                      {"£" +
                        addCommas(
                          calculateTotalValue(miSliderValue).toFixed(2) //eslint-disable-line
                        )}{" "}
                    </div>
                  </div>
                  <div className="parent-text">
                    <div className="current-value-text">Current incomes:</div>
                    <div className="current-value">
                      {"£" +
                        addCommas(
                          calculateMonthlyIncome(
                            calculateTotalValue(miSliderValue).toFixed(2),
                            miRate,
                            currentPriceManaged //eslint-disable-line
                          ).toFixed(2) //eslint-disable-line
                        )}{" "}
                      p/m
                    </div>
                  </div>
                  <hr className="lower-line" />
                  <p className="fund-desc">
                    {
                      cmsStrategy?.find(
                        (fund) => fund?.strategyName === "Managed Income Fund" //eslint-disable-line
                      )?.shortDesc
                    }
                  </p>
                  <Row className="fund-text slider-card-section">
                    <Col lg={7} md={7} className="card-slide">
                      <Slider
                        onChange={handleMiSliderChange}
                        value={miSliderValue}
                        minValue="0"
                        maxValue="100"
                        step="1"
                        className="change-investment-slider"
                      />
                    </Col>
                    <Col lg={4} md={4} className="card-input">
                      <input
                        type="text"
                        className="input-text"
                        value={`${miSliderValue}%`}
                        onChange={handleMiInputChange}
                        onBlur={handleMiInputBlur}
                        min="0"
                        max="100"
                      />
                    </Col>
                  </Row>
                  <div className="button-align">
                    <div className="view-fund-button">
                      <Buttons
                        name="View full fund fact sheet"
                        className="tertiary"
                        handleClick={() =>
                          openPopup(
                            cmsStrategy?.find(
                              (fund) =>
                                fund?.strategyName === "Managed Income Fund" //eslint-disable-line
                            )?.pDFUrl //eslint-disable-line
                          )
                        }
                      ></Buttons>
                    </div>
                    <div>
                      <Buttons
                        name="See product guide"
                        className="secondary"
                        handleClick={() => {
                          generateProductOverviewLink(
                            "TPT drawdown",
                            "Managed income",
                          );
                        }}
                      ></Buttons>
                    </div>
                  </div>
                </div>
                <div className="retirement-card">
                  <div className="sub-header-div">
                    <span
                      className="circle ps-2 mt-1"
                      style={{
                        backgroundColor: COLOR_PALETTE[0],
                      }}
                    ></span>
                    <span className="sub-header">Future annuity income</span>
                  </div>
                  <hr className="upper-line" />
                  <div className="parent-text">
                    <div className="current-value-text">Current value:</div>
                    <div className="current-value">
                      {"£" +
                        addCommas(
                          calculateTotalValue(futureSliderValue).toFixed(2) //eslint-disable-line
                        )}{" "}
                    </div>
                  </div>
                  <div className="parent-text">
                    <div className="current-value-text">Current income:</div>
                    <div className="current-value">
                      {"£" +
                        addCommas(
                          calculateMonthlyIncome(
                            calculateTotalValue(futureSliderValue).toFixed(2),
                            faRate,
                            currentPriceFutureAnnuity //eslint-disable-line
                          ).toFixed(2) //eslint-disable-line
                        )}{" "}
                      p/m
                    </div>
                  </div>
                  <hr className="lower-line" />
                  <p className="fund-desc">
                    {
                      cmsStrategy?.find(
                        (fund) =>
                          fund?.strategyName === "Future Annuity Income Fund" //eslint-disable-line
                      )?.shortDesc
                    }{" "}
                  </p>
                  <Row className="fund-text slider-card-section">
                    <Col lg={7} md={7} className="card-slide">
                      <Slider
                        onChange={handleFutureSliderChange}
                        value={futureSliderValue}
                        minValue="0"
                        maxValue="100"
                        step="1"
                        className="change-investment-slider"
                      />
                    </Col>
                    <Col lg={4} md={4} className="card-input">
                      <input
                        type="text"
                        className="input-text"
                        value={`${futureSliderValue}%`}
                        onChange={handleFutureInputChange}
                        min="0"
                        max="100"
                      />
                    </Col>
                  </Row>
                  <div className="button-align">
                    <div className="view-fund-button">
                      <Buttons
                        name="View full fund fact sheet"
                        className="tertiary"
                        handleClick={() =>
                          openPopup(
                            cmsStrategy?.find(
                              (fund) =>
                                fund?.strategyName ===
                                "Future Annuity Income Fund" //eslint-disable-line
                            )?.pDFUrl //eslint-disable-line
                          )
                        }
                      ></Buttons>
                    </div>
                    <div>
                      <Buttons
                        name="See product guide"
                        className="secondary"
                        handleClick={() => {
                          generateProductOverviewLink(
                            "TPT drawdown",
                            "Future annuity",
                          );
                        }}
                      ></Buttons>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="managed-income">
            <div className="managed-income-heading">
              <span className="manage-heading-text">{"Self-managed"}</span>
            </div>
            <div className="d-flex g-4">
              <div className="retirement-card">
                <div className="sub-header-div">
                  <span
                    className="circle ps-2 mt-1"
                    style={{
                      backgroundColor: COLOR_PALETTE[0],
                    }}
                  ></span>
                  <span className="sub-header">Flexi-access</span>
                </div>
                <hr className="upper-line" />
                <div className="parent-text">
                  <div className="current-value-text">Current value:</div>
                  <div className="current-value">
                    {"£" +
                      addCommas(
                        calculateTotalValue(flexiSliderValue).toFixed(2) //eslint-disable-line
                      )}{" "}
                  </div>
                </div>
                <div className="parent-text">
                  <div className="current-value-text">Current income:</div>
                  <div className="current-value">
                    {"£" +
                      addCommas(
                        currentIncome //eslint-disable-line
                      )}{" "}
                    {frequency === "Monthly"
                      ? "p/m"
                      : frequency === "Quarterly"
                        ? "p/q"
                        : frequency === "HalfYearly"
                          ? "p/6m"
                          : frequency === "Annual"
                            ? "p/y"
                            : ""}
                  </div>
                </div>
                <hr className="lower-line" />
                <p className="fund-desc">
                  A fully flexible option where you decide the funds you’d like
                  to invest, when you take out money and how much.
                </p>
                <Row className="fund-text slider-card-section">
                  <Col lg={7} md={7} className="card-slide">
                    <Slider
                      onChange={handleFlexiSliderChange}
                      value={flexiSliderValue}
                      minValue="0"
                      maxValue="100"
                      step="1"
                      className="change-investment-slider"
                    />
                  </Col>
                  <Col lg={4} md={4} className="card-input">
                    <input
                      type="text"
                      className="input-text"
                      value={`${flexiSliderValue}%`}
                      onChange={handleFlexiInputChange}
                      min="0"
                      max="100"
                    />
                  </Col>
                </Row>
                <div className="button-align-flexi">
                  <div>
                    <Buttons
                      name="See product guide"
                      className="secondary"
                      handleClick={() => {
                        generateProductOverviewLink(
                          "Take regular income",
                          "Self-managed regular income",
                        );
                      }}
                    ></Buttons>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />
            <div>
              <span className="funds-selected">
                Allocated: {Number(totalSliderValue)}%
              </span>
              <Buttons
                handleClick={() => {
                  if (Number(flexiSliderValue) > 0) {
                    if (
                      movingToDrawdownValue >= 22500 &&
                      (isBetween0And22500(calculateTotalValue(miSliderValue)) ||
                        isBetween0And22500(
                          calculateTotalValue(futureSliderValue) //eslint-disable-line
                        ))
                    ) {
                      setManagedForYouErrorPopup(true);
                    } else setFlexiIncomePopup(true);
                  } else {
                    if (
                      movingToDrawdownValue >= 22500 &&
                      (isBetween0And22500(calculateTotalValue(miSliderValue)) ||
                        isBetween0And22500(
                          calculateTotalValue(futureSliderValue) //eslint-disable-line
                        ))
                    ) {
                      setManagedForYouErrorPopup(true);
                    } else handleContinue();
                  }
                }}
                className="primary"
                name="Continue"
                disabled={Number(totalSliderValue) === 100 ? false : true}
              />
            </div>
          </div>
          <ModalOverlay
            popup="choosingFlexiAccessRetirement"
            show={flexiIncomePopup}
            onHide={(e) => {
              if (e !== undefined) {
                e.preventDefault();
              }
              setFlexiIncomePopup(false);
            }}
            modaltitle="Choosing flexi-access"
            flexiAcessCurrentIncome={flexiAccessCurrentIncome}
            flexiAccessDuration={flexiAccessDuration}
            flexiAccessTotalValue={parseFloat(
              calculateTotalValue(flexiSliderValue).toFixed(2) //eslint-disable-line
            )}
            handleFlexiAccessContinue={(amount, period) => {
              handleFlexiAccessContinue(amount, period);
              let currentStep = RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST;
              let regularIncome = {
                active: true,
                faFequency: period
                  ? period === "Annually"
                    ? "Annual"
                    : period === "Half yearly"
                      ? "HalfYearly"
                      : period === "Quarterly"
                        ? "Quarterly"
                        : "Monthly"
                  : "Monthly",
                faPercent: parseFloat(flexiSliderValue),
                miAllocationPercent: parseFloat(miSliderValue),
                faIncomePercentage: parseFloat(futureSliderValue),
                faAmount: calculateTotalValue(flexiSliderValue).toFixed(2),
                faChoosenAmount: Number(
                  String(amount ?? "")
                    ?.replace("£", "")
                    .trim() //eslint-disable-line
                ),
                miAmount: calculateTotalValue(miSliderValue).toFixed(2),
                faIncomeAmount:
                  calculateTotalValue(futureSliderValue).toFixed(2),
                miCurrentIncome: calculateMonthlyIncome(
                  calculateTotalValue(miSliderValue).toFixed(2),
                  miRate,
                  currentPriceManaged //eslint-disable-line
                ).toFixed(2),
                faiCurrentIncome: calculateMonthlyIncome(
                  calculateTotalValue(futureSliderValue).toFixed(2),
                  faRate,
                  currentPriceFutureAnnuity //eslint-disable-line
                ).toFixed(2),
              };
              let payload = {
                currentStep,
                choiceCategory: { regularIncome },
              };
              props.nextStepIndentifier(
                RA_STEPS_IDENTIFIERS.RA_RI_INVEST_THE_REST,
                payload // eslint-disable-line
              );
            }}
            isCancel={false}
          />
          <ModalOverlay
            popup="LeavingTPTSuccessModel"
            show={managedForYouErrorPopup}
            onHide={() => setManagedForYouErrorPopup(false)}
            description={
              <>
                To proceed, choose a value of £22,500 or higher for{" "}
                <i>Managed for you</i> options.
              </>
            }
            btnContinuedName="Got it!"
            handleClick={() => {
              setManagedForYouErrorPopup(false);
            }}
          />
        </Card.Body>
      </Card>
    </>
  );
};
export default TakingRegularIncome;
